import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi } from '@shared/api/rest';
import type { TransferRequestLimitsResponse } from '@shared/api/rest/transferRequests';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams) => TransferRequestsApi.getLimits(params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestLimitsResponse>({
  outgoingTransferLimit: 0,
})
  .on(effect.done, (_, data) => data.result.data ?? { outgoingTransferLimit: 0 })
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsLimitsStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
